import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { PermissionNames, PermissionOperations } from "~enums/permissions";
import type { SelectBaseSingleProperties } from "~types/selectBaseSingleProperties";
import { InfinitySelect, type InfinitySelectOption } from "~components/InfinitySelect";
import { StandingConfigurationResponse } from "~types/standingConfiguration.ts";

type Props = SelectBaseSingleProperties<InfinitySelectOption>;

export const SelectStandingConfiguration = ({ value, ...props }: Props) => {
  const { sport, organizationId } = useParams();

  const onConvertResponseIntoOptionsHandler = (response: StandingConfigurationResponse) =>
    (response?.data || []).map((x) => ({ label: x.nameLocal, value: x.standingConfigurationId }));

  return (
    <InfinitySelect<StandingConfigurationResponse>
      {...props}
      url={`${sport}/o/${organizationId}/standings/configurations`}
      values={isEmpty(value) ? [] : [value]}
      onConvertResponseIntoOptions={onConvertResponseIntoOptionsHandler}
      permissionName={PermissionNames.STANDING_CONFIGURATION}
      permissionOperation={PermissionOperations.READ}
    />
  );
};
